/*
    Copyright NetFoundry Inc.

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

    https://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/

import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Router} from "@angular/router";

@Component({
  selector: 'lib-quick-add',
  templateUrl: './quick-add.component.html',
  styleUrls: ['./quick-add.component.scss']
})
export class QuickAddComponent {

  constructor(
    private dialogRef: MatDialogRef<QuickAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
  ) {

  }

  identityLinkClicked(event) {
    this.router.navigateByUrl('/identities/create');
    event.preventDefault();
    this.close()
  }

  serviceLinkClicked(event) {
    this.router.navigateByUrl('/services/simple');
    event.preventDefault();
    this.close()
  }

  close() {
    this.dialogRef.close();
  }
}
